/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) Diagnostic Battery Icon
 * component - the "Device Battery" glyph shown in the Asset Summary Card's
 * Diagnostic Summary Bar (ION-7392/ION-7398). Previously drew its own
 * bordered chip frame around the whole icon (a rounded-rect stroke) - that
 * outer box didn't match every other Health indicator, which just show a
 * plain icon with no frame, so it's been dropped here too.
 */
export const DiagnosticBatteryIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M17.1909 16.5H3.4341C3.19535 16.5 3 16.3152 3 16.0892V7.91077C3 7.68485 3.19535 7.5 3.4341 7.5L17.1909 7.5C17.4297 7.5 17.625 7.68485 17.625 7.91077V16.0892C17.625 16.3172 17.4297 16.5 17.1909 16.5Z' fill={iconColor} />
      <path d='M21 15.1913V8.80792H18.7024V15.1913H21Z' fill={iconColor} />
      <path d='M15.75 15V9H4.5V15H15.75Z' fill={iconColor} />
    </svg>
  );
};

export default DiagnosticBatteryIcon;
